import React from "react";
import Sentry from "../sentry";

// Filet de sécurité : capture toute erreur de rendu React pour éviter la
// page blanche, et affiche un message propre avec un bouton de rechargement.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Erreur non gérée (ErrorBoundary) :", error, info);
    // Remonte l'erreur à Sentry (no-op si aucun DSN configuré).
    Sentry.captureException(error, { extra: { componentStack: info?.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            padding: "24px",
            textAlign: "center",
            fontFamily: "system-ui, -apple-system, Arial, sans-serif",
            color: "#0a2530",
            background: "linear-gradient(160deg, #e8f4f8, #dbeaf0)",
          }}
        >
          <h1 style={{ margin: 0, fontSize: "22px", color: "var(--primary-blue)" }}>
            Oups, une erreur est survenue
          </h1>
          <p style={{ margin: 0, maxWidth: "360px", lineHeight: 1.5, color: "#425a63" }}>
            Quelque chose s'est mal passé de notre côté. Recharge la page pour
            continuer, tes données sont en sécurité.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "6px",
              padding: "11px 22px",
              borderRadius: "10px",
              border: "none",
              background: "var(--primary-blue)",
              color: "#fff",
              fontWeight: 700,
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
